import { useState, useEffect } from 'react';
import { fetchPartnerClient, createPartnerClient, updatePartnerClient } from 'admin/actions/partner-client';

const usePartnerClient = (partnerClientId) => {
  const initialValues = {
    id: '',
    name: '',
    organization: null,
    admin_user: null,
    description: '',
    status: '',
  };

  const [partnerClient, setPartnerClient] = useState(initialValues);
  const [error, setError] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getPartnerClient = async (id) => {
    setIsLoading(true);
    await fetchPartnerClient(id)
      .then((o) => setPartnerClient(o))
      .catch((e) => setError(e))
      .finally(() => setIsLoading(false));
  };

  const submitUpdate = async (id, params, onSuccess) => {
    setIsLoading(true);
    await updatePartnerClient(id, params)
      .then((o) => {
        setPartnerClient(o);
        onSuccess();
      })
      .catch((e) => setError(e))
      .finally(() => setIsLoading(false));
  };

  const submitCreate = async (params, onSuccess) => {
    setIsLoading(true);
    await createPartnerClient(params)
      .then((o) => {
        setPartnerClient(o);
        onSuccess();
      })
      .catch((e) => setError(e))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    if (typeof partnerClientId == 'string') {
      if (partnerClientId != 'new') {
        getPartnerClient(partnerClientId);
      }
    }
  }, [partnerClientId]);

  return { partnerClient, initialValues, submitUpdate, submitCreate, error, isLoading };
};

export default usePartnerClient;
